// umlaut-check: skip — technische Schlüssel der Bestandskennzahlen (JSON-Schnittstelle).
import React from 'react';
import BestandTooltip, {werteAusKennzahlen} from '../Stock/BestandTooltip';
import {BEGRIFF, menge} from '../Stock/bestandTexte';
import {availOf, isExcluded, isStockInPflege, sourceWarehouseFor} from './availability';

/**
 * Bestandszahlen einer Position unter der Ampel (einheitliche Bestandsregel,
 * Auftrag #315): „verfügbar“, darin „davon für diesen Auftrag reserviert“ und
 * grau „offen, nicht reserviert“. Alles hängt an EINEM Tooltip mit dem festen
 * Erklärtext; die reservierenden Lieferscheine/Aufträge werden beim Öffnen
 * nachgeladen.
 *
 * Neu hinzugefügte und geladene Positionen zeigen dieselbe Zahl, weil beide
 * aus demselben Rechenweg (AvailabilityService) kommen.
 */
export default function StockFigures({row, stock, order, orderRef}) {
    if (!row.articleId || isExcluded(row) || !stock.loaded) {
        return null;
    }

    const figures = availOf(row, stock, order);
    if (!figures) {
        return null;
    }

    const warehouseId = sourceWarehouseFor(row, stock, order);
    const warehouse = ((stock.warehouses || []).find((w) => String(w.id) === String(warehouseId)) || {}).name || '';
    const pflege = isStockInPflege(row, stock, order);

    const werte = werteAusKennzahlen(figures);

    return (
        <BestandTooltip
            werte={werte}
            lagerName={warehouse}
            quelle={'Live aus Weclapp, gerechnet beim Öffnen des Belegs bzw. nach der letzten Buchung.'
                + (pflege ? ' Der Lahr-Bestand wird noch aufgebaut, die Zahl kann ein Platzhalter sein.' : '')}
            haelterUrl={orderRef && row.articleId ? `/order-editor/${encodeURIComponent(orderRef)}/reservations/${encodeURIComponent(row.articleId)}` : undefined}
            haelterParams={{warehouse: warehouseId}}
        >
            <span className="av-fig" tabIndex={0} role="group" aria-label="Bestand dieser Position">
                <span>{BEGRIFF.verfuegbar} <b>{menge(figures.verfuegbar)}</b></span>
                {figures.reserviert_eigen > 0 ? (
                    <span>davon für diesen Auftrag {BEGRIFF.reserviert} <b>{menge(figures.reserviert_eigen)}</b></span>
                ) : null}
                {figures.offen_nicht_reserviert > 0 ? (
                    <span className="av-fig-gray">{BEGRIFF.offenNichtReserviert} {menge(figures.offen_nicht_reserviert)}</span>
                ) : null}
            </span>
        </BestandTooltip>
    );
}
